import screenPositionOnSelect from './customizations/screenPositionOnSelect'

import * as events from '@/events'
import { getValidRanges } from '@/utils/getValidRanges'

const $ = require('jquery')
const moment = require('moment')

const { globals } = require('./globals')

function SearchFilterController (container, isSimpleMode) {
  if (!container || !container[0])
    return

  this.isSimpleMode = isSimpleMode
  this.container = container
  this.model = this.buildModel(container)
  this.uiUdpateInProgress = false
  this.globalRequestNumber = 0
}

SearchFilterController.prototype.buildModel = function(container) {
  const self = this

  const model = {
    regions: new MultiSelect(container.find('.custom-select-country')),
    airports: new MultiSelect(container.find('.custom-select-airport')),
    period: new DateSelect(container.find('.custom-select-date')),
    durations: new SingleSelect(container.find('.custom-select-duration')),
    people: new PeopleCountSelect(container.find('.custom-select-people')),
    prices: new SingleSelect(container.find('.custom-select-price-person')),
    rooms: new SingleSelect(container.find('.custom-select-room')),
    meals: new SingleSelect(container.find('.custom-select-food')),
    submitButton: new SubmitButton(container.find('.btn-cta')),
  }

  const callSearch = function() {
    return self.callSearch()
  }

  model.regions.initOnChange(callSearch)
  model.airports.initOnChange(callSearch)
  model.period.initOnChange(callSearch)
  model.durations.initOnChange(callSearch)
  model.people.initOnChange(callSearch)
  model.prices.initOnChange(callSearch)
  model.rooms.initOnChange(callSearch)
  model.meals.initOnChange(callSearch)

  return model
}

SearchFilterController.prototype.updateUI = function(searchResult) {
  if (!searchResult.Status.IsValid) {
    log.warn(`Failed to update filters. Status: ${searchResult.Status.Status} Message: ${searchResult.Status.Message}`)
    return
  }

  const isDateSeyByUrl = window.location.href.indexOf('DateOfDeparture') >= 0 || window.location.href.indexOf('DateOfReturn') >= 0
  const shouldSetDateRange = !isDateSeyByUrl && !this.isSimpleMode && this.globalRequestNumber === 1

  // Check for no results
  if (!this.model.regions.hasAnySelectedItems(searchResult.Destinations) ||
        !this.model.airports.hasAnySelectedItems(searchResult.DestinationAirports) ||
        !this.model.durations.hasSelectedItem(searchResult.Durations) ||
        !this.model.prices.hasSelectedItem(searchResult.Prices)) {

    searchResult.hasNoResults = true
  }

  // Check for picker changes
  let missingSelectedOptions = false
  if (!this.model.regions.hasAllSelectedItems(searchResult.Destinations) ||
        !this.model.airports.hasAllSelectedItems(searchResult.DestinationAirports)) {

    missingSelectedOptions = true
  }

  this.model.regions.setAvailableOptions(searchResult.Destinations, searchResult.hasNoResults || missingSelectedOptions)
  this.model.airports.setAvailableOptions(searchResult.DestinationAirports, searchResult.hasNoResults || missingSelectedOptions)
  this.model.period.setAvailableRange(searchResult.Durations, searchResult.MinDate, searchResult.MaxDate, shouldSetDateRange, searchResult.hasNoResults, missingSelectedOptions)
  this.model.durations.setAvailableOptions(searchResult.Durations, searchResult.hasNoResults || missingSelectedOptions)
  this.model.people.setAvailableRange(1, searchResult.MaxAdultsCount, 0, 6, searchResult.hasNoResults || missingSelectedOptions)
  this.model.prices.setAvailableOptions(searchResult.Prices, searchResult.hasNoResults || missingSelectedOptions)
  this.model.rooms.setAvailableOptions(searchResult.Rooms, searchResult.hasNoResults || missingSelectedOptions)
  this.model.meals.setAvailableOptions(searchResult.Meals, searchResult.hasNoResults || missingSelectedOptions)

  this.model.submitButton.setState(searchResult.hasNoResults)
  globals.initialFilterData = searchResult
}

SearchFilterController.prototype.getCurrentFilters = function() {
  function getUrlParameterByName (name, url) {
    if (!url) {
      url = window.location.href
    }

    name = name.replace(/[[\]]/g, '\\$&')
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
    const results = regex.exec(url)

    if (!results)
      return null

    if (!results[2])
      return ''

    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  const filters = {
    Destinations: this.model.regions.getValue(),
    DestinationAirports: this.model.airports.getValue(),
    Duration: this.model.durations.getValue(),
    Price: this.model.prices.getValue(),
    DepartureDateMin: this.model.period.getValue().min,
    ReturnDateMax: this.model.period.getValue().max,
    AdultsCount: this.model.people.getValue().adultsCount,
    ChildrenCount: this.model.people.getValue().childrenCount,
    ChildrenBirthDates: this.model.people.getValue().childrenBirthDates,
    Room: this.model.rooms.getValue(),
    Food: this.model.meals.getValue(),
    OfferId: getUrlParameterByName('offercode'),
  }

  return filters
}

SearchFilterController.prototype.callSearch = function() {
  if (!this.container || !this.container[0] || this.uiUdpateInProgress)
    return null

  const self = this
  const dfd = $.Deferred()
  const filters = this.getCurrentFilters()
  const requestNumber = ++this.globalRequestNumber

  function getHotelSlug () {
    const splittedUrl = window.location.href.split('/')
    const query = splittedUrl[splittedUrl.length - 1]
    const hotelSlug = query.split('?', 1)[0]

    return `?hotelSlug=${hotelSlug}`
  }

  $.ajax({
    crossDomain: true,
    type: 'POST',
    url: `/api/sitecore/searchfilter/search${getHotelSlug()}`,
    data: JSON.stringify(filters),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
  })
    .done(function(searchResult) {
      const result = new SearchResult(searchResult)

      const isNewerRequestPending = requestNumber < self.globalRequestNumber
      if (isNewerRequestPending) {
        return null
      }

      try {
        self.uiUdpateInProgress = true
        self.updateUI(result)
      }
      finally {
        self.uiUdpateInProgress = false
      }

      return dfd.resolve(result)
    })
    .fail(function(data) {
      log.warn('Failed to load call filter service')
      dfd.reject(data)
    })

  return dfd.promise()
}

function MultiSelect (element) {
  if (!element || !element[0]) {
    return
  }

  this.element = element
  this.availableOptions = []
}

MultiSelect.prototype.getUiHandlers = function(element) {
  const elementToListItem = (element, index) => ({
    [element.value]: {
      li: $(element).find(`ul.dropdown-menu li[data-original-index="${index}"]`),
      option: $(element),
    },
  })
  const collectListItems = (acc, element, index) => Object.assign({}, acc, elementToListItem(element, index))
  const options = element.get(0).querySelectorAll('select option')
  return options.reduce(collectListItems, {})
}

MultiSelect.prototype.setAvailableOptions = function(availableOptions, hasNoResults) {
  if (!availableOptions)
    return

  this.availableOptions = availableOptions

  if (!this.element || !this.element[0]) {
    return
  }

  // UI elements are refreshed - we need to get current handlers
  const options = this.getUiHandlers(this.element)
  let value

  for (value in options) {

    const valueSplited = decodeURIComponent(value).split(',')
    const valueIntersection = availableOptions.filter(v => valueSplited.indexOf(v) !== -1)

    if (valueIntersection.length > 0) {
      options[value].option.prop('disabled', false)
    } else {

      if (options[value].li.hasClass('selected') && !hasNoResults)
        options[value].li.find('a').click()

      options[value].option.prop('disabled', true)
    }
  }

  // Refresh is requierd to show options hidden before
  // Rendered event will be called but uiUdpateInProgress will prevent search
  this.element.find('select').selectpicker('refresh')
}

MultiSelect.prototype.hasAllSelectedItems = function(availableOptions) {
  if (!availableOptions)
    return false

  if (!this.element || !this.element[0]) {
    return true
  }

  const selected = this.getValue()
  const result = selected.filter(function(selectedItem) { return availableOptions.indexOf(selectedItem) > -1 })
  return result.length == selected.length
}

MultiSelect.prototype.hasAnySelectedItems = function(availableOptions) {
  if (!availableOptions)
    return false

  if (!this.element || !this.element[0]) {
    return true
  }

  const selected = this.getValue()
  const result = selected.filter(function(selectedItem) { return availableOptions.indexOf(selectedItem) > -1 })
  return selected.length === 0 || result.length > 0
}

MultiSelect.prototype.getValue = function() {
  return (!this.element || !this.element[0]) ? null : this.element.find('select option:selected').map(function() { return $(this).val() }).toArray().reduce((r, a) => r.concat(decodeURIComponent(a.toString()).split(',')), [])
}

MultiSelect.prototype.initOnChange = function(handler) {
  if (!handler || !this.element || !this.element[0])
    return

  this.element.find('select')
    .on('rendered.bs.select', function() {
      handler()
    })
}

function SingleSelect (element, callback) {
  this.callback = callback
  const self = this

  if (!element || !element[0]) {
    return
  }

  this.element = element
  this.options = {}

  this.element.find('.radio').each(function(e, i) {
    const input = $(i).find('input')
    const label = $(i).find('label')
    const value = input.val()
    self.options[value] = {
      div: $(i),
      input,
      label,
    }

    // Disabling click on label events
    const clickHandlers = $._data(label[0], 'events').click
    for (let i = 0; i < clickHandlers.length; i++) {
      const handler = clickHandlers[i].handler

      clickHandlers[i].handler = function() {
        const inputId = $(this).attr('for')
        const isDisabled = $(`#${inputId}`).prop('disabled')

        if (!isDisabled) {
          handler.apply(this, arguments)
        }
      }
    }
  })
}

SingleSelect.prototype.setAvailableOptions = function(availableOptions, hasNoResults) {
  if (!availableOptions)
    return

  log.debug('SingleSelect.setAvailableOptions(availableOptions:', availableOptions, ', hasNoResults: ', hasNoResults)

  this.availableOptions = availableOptions

  if (!this.element || !this.element[0]) {
    return
  }

  if (availableOptions.length == 0 && !hasNoResults) {
    this.element.find('.section-label').prop('disabled', true)
    this.element.find('.section-title').text(this.element.find('.section-label').text())
    this.element.find('.radio input[type="radio"]:checked').prop('checked', false)
  }

  let value

  for (value in this.options) {
    if (/^\s*$/.test(value)) {
      this.options[value].input.prop('disabled', true)
      this.options[value].div.hide()
    } else if (value === '0:0') {
      this.options[value].input.prop('disabled', false)
      this.options[value].div.toggleClass('disabled', false)
    } else if (availableOptions.indexOf(value) >= 0 || value.indexOf(':') === -1) {
      const isAvaiable = availableOptions.indexOf(value) >= 0
      this.options[value].input.prop('disabled', !isAvaiable)
      this.options[value].div.toggleClass('disabled', !isAvaiable)
    } else {
      const min = parseInt(value.split(':')[0])
      const max = parseInt(value.split(':')[1])

      let isInRange = false

      for (let i = 0; i < availableOptions.length; i++) {
        isInRange = availableOptions[i] >= min && availableOptions[i] <= max
        if (isInRange) {
          break
        }
      }

      this.options[value].input.prop('disabled', !isInRange)
      this.options[value].div.toggleClass('disabled', !isInRange)
    }
  }
}

SingleSelect.prototype.hasSelectedItem = function(availableOptions) {
  if (!availableOptions)
    return false

  if (!this.element || !this.element[0]) {
    return true
  }

  const value = this.getValue()

  if (!value || /^\s*$/.test(value) || value === '0:0') {
    return true

  } else if (availableOptions.indexOf(value) >= 0 || value.indexOf(':') === -1) {
    return availableOptions.indexOf(value) >= 0

  } else {
    const min = parseInt(value.split(':')[0])
    const max = parseInt(value.split(':')[1])

    let isInRange = false
    for (let i = 0; i < availableOptions.length; i++) {
      isInRange = availableOptions[i] >= min && availableOptions[i] <= max
      if (isInRange) {
        break
      }
    }

    return isInRange
  }
}

SingleSelect.prototype.getValue = function() {
  return (!this.element || !this.element[0]) ? null : this.element.find('.radio input[type="radio"]:checked').val()
}

SingleSelect.prototype.initOnChange = function(handler) {
  if (!handler || !this.element || !this.element[0])
    return

  this.element.find('.radio input')
    .on('change', function() {
      handler()
    })
}

function DateSelect (element) {
  const self = this

  if (!element[0]) {
    return
  }

  this.handlerPromise = null
  this.element = element
  this.element.find('.custom-select-date__container').on('closed', self.showMessage.bind(this))
}

DateSelect.prototype.setAvailableRange = function(availableDays, minDate, maxDate, setDatesToMinMax, noResults, affectOtherPickers) {
  log.debug('DateSelect.setAvailableRange(availableDays', availableDays, 'minDate:', minDate.format('YYYY-MM-DD'), 'maxDate:', maxDate.format('YYYY-MM-DD'), 'setDatesToMinMax:', setDatesToMinMax, 'noResults:', noResults, 'affectOtherPickers', affectOtherPickers, ')')

  events.searchDataReceived({
    minDate,
    maxDate,
    validRanges: getValidRanges(availableDays),
  })

  const self = this

  if (!this.element[0]) return
  if (!minDate || !maxDate) return

  // TODO: fix that - there should be no reaching out beyond this point as it breaks encapsulation
  self.noResults = noResults
  self.affectOtherPickers = affectOtherPickers
}

DateSelect.prototype.getValue = function() {
  if (!this.element || !this.element[0] || this.element.find('.section-title').html().indexOf('od-do...') >= 0) {
    return {
      min: null,
      max: null,
    }
  }

  const departureFrom = this.element.find('.form-group:eq(0) .form-control').val()
  const departureTo = this.element.find('.form-group:eq(1) .form-control').val()

  return {
    min: departureFrom !== '01.01.1970' ? moment(departureFrom, 'DD.MM.YYYY').toDate() : null,
    max: departureTo !== '01.01.1970' ? moment(departureTo, 'DD.MM.YYYY').toDate() : null,
  }
}

DateSelect.prototype.initOnChange = function(handler) {
  const self = this

  if (!handler || !this.element || !this.element[0])
    return

  this.element.find('.custom-select-date__container').on('change', () => {
    log.debug('DateSelect.prototype.initOnChange - change event handler')
    self.handlerPromise = handler()
  })
}

DateSelect.prototype.showMessage = function() {
  const self = this

  $.when(self.handlerPromise).then(function() {
    const isDatePickerOpen = self.element.find('.custom-select-date__container').hasClass('show')
    const isDatePickerSet = self.element.find('.section-title').html().indexOf('od-do...') === -1

    if (self.noResults && isDatePickerSet && !isDatePickerOpen) {

      $('.custom-select-date__error-msg').html('Przykro nam, ale nie możemy zaproponować ofert <strong>w wybranym terminie</strong>. Spróbój zmienić planowany termin wylotu i znajdz swoje wymarzone wakacje.')
      $('.custom-select-date__error').addClass('show')
    }
    else if (self.affectOtherPickers && isDatePickerSet && !isDatePickerOpen) {

      $('.custom-select-date__error-msg').html('Przykro nam ale w wybranym terminie <strong>nie wszystkie</strong> wybrane przez Ciebie kierunki lub lotniska są dostępne.')
      $('.custom-select-date__error').addClass('show')

    } else {

      $('.custom-select-date__error').removeClass('show')
    }
  })
}

function PeopleCountSelect (element) {
  if (!element[0]) {
    return
  }

  this.element = element
}

PeopleCountSelect.prototype.setAvailableRange = function(minAdults, maxAdults, minChildren, maxChildren, hasNoResults) {

  const currentValue = this.getValue()

  const infant = 1
  const calculatedMaxAdults = maxAdults - (currentValue.childrenCount ? currentValue.childrenCount - infant : 0)
  const calculatedMaxChildren = currentValue.adultsCount ? Math.min(Math.max((maxAdults - currentValue.adultsCount + infant), 0), maxChildren) : 0

  const isOpen = this.element.hasClass('open')

  // Adult
  const adultsCountInput = this.element.find('.form-group:eq(0) input.form-control')
  const removeAdultButton = this.element.find('.form-group:eq(0) span.remove-item')
  const addAdultButton = this.element.find('.form-group:eq(0) span.add-item')

  adultsCountInput.attr('data-val-range-min', minAdults)
  adultsCountInput.attr('data-val-range-max', calculatedMaxAdults)

  let max = parseInt(adultsCountInput.attr('data-val-range-max'))
  const currentAdultsValue = parseInt(adultsCountInput.val())
  addAdultButton.toggle(currentAdultsValue < max)

  while ((!hasNoResults || isOpen) && parseInt(adultsCountInput.val()) > calculatedMaxAdults) {
    // Go to allowed value
    removeAdultButton.click()
  }

  // Children
  const childrenCountInput = this.element.find('.form-group:eq(1) input.form-control')
  const removeChildrenButton = this.element.find('.form-group:eq(1) span.remove-item')
  const addChildrenButton = this.element.find('.form-group:eq(1) span.add-item')

  childrenCountInput.attr('data-val-range-min', minChildren)
  childrenCountInput.attr('data-val-range-max', calculatedMaxChildren)

  max = parseInt(childrenCountInput.attr('data-val-range-max'))
  const currentChildrenCount = parseInt(childrenCountInput.val())
  addChildrenButton.toggle(currentChildrenCount < max)

  while ((!hasNoResults || isOpen) && parseInt(childrenCountInput.val()) > calculatedMaxChildren) {
    // Go to allowed value
    removeChildrenButton.click()
  }

  // Message
  let message = ''

  if (currentValue.adultsCount === calculatedMaxAdults)
    message = `Wybrany kierunek posiada pokoje do ${maxAdults} OS. DOROSŁYCH`

  if ((currentValue.adultsCount + currentValue.childrenCount) === (calculatedMaxAdults + calculatedMaxChildren))
    message = `Wybrany kierunek posiada pokoje do ${maxAdults + infant} OS. ŁĄCZNIE`

  if (message) {
    this.element.addClass('has-msg')
    this.element.find('.custom-select-people__msg').html(message)
  }
  else {
    this.element.removeClass('has-msg')
  }
}

PeopleCountSelect.prototype.getValue = function() {
  if (!this.element || !this.element[0])
    return null

  const adultsCount = this.element.find('.form-group:eq(0) input.form-control').val()
  const childrenCount = this.element.find('.form-group:eq(1) input.form-control').val()

  return {
    adultsCount: adultsCount ? parseInt(adultsCount) : 0,
    childrenCount: childrenCount ? parseInt(childrenCount) : 0,
    childrenBirthDates: this.element
      .find('.dropdown-menu .dropdown-menu__inner [style*="display: block"].form-group input.form-control')
      .filter(`:lt(${childrenCount})`)
      .map(function() { return moment($(this).val(), 'DD.MM.YYYY').toDate() })
      .get(),
  }
}

PeopleCountSelect.prototype.initOnChange = function(handler) {
  if (!handler || !this.element || !this.element[0])
    return

  const adultsCountInput = this.element.find('.form-group:eq(0) input.form-control')
  const addAdultButton = this.element.find('.form-group:eq(0) span.add-item')

  this.element.find('.form-group:eq(0) span.add-item, .form-group:eq(0) span.remove-item').on('click', function() {
    setTimeout(function() {
      const max = parseInt(adultsCountInput.attr('data-val-range-max'))
      const currentValue = parseInt(adultsCountInput.val())
      addAdultButton.toggle(currentValue < max)

      handler()
    }, 100)
  })

  const childrenCountInput = this.element.find('.form-group:eq(1) input.form-control')
  const addChildButton = this.element.find('.form-group:eq(1) span.add-item')

  const onChangeHandler = function() {
    setTimeout(function() {
      const max = parseInt(childrenCountInput.attr('data-val-range-max'))
      const currentValue = parseInt(childrenCountInput.val())
      addChildButton.toggle(currentValue < max)

      handler()
    }, 100)
  }

  this.element.find('.dropdown-menu .dropdown-menu__inner input.form-control').on('dp.change', onChangeHandler)
  this.element.find('.form-group:eq(1) span.add-item, .form-group:eq(1) span.remove-item').on('click', onChangeHandler)
}

function SubmitButton (element) {
  if (!element || !element[0]) {
    return
  }

  this.element = element
}

SubmitButton.prototype.setState = function(isDisabled) {
  this.element.find('input[type="submit"]').attr('disabled', isDisabled)
  this.element.addClass('btn').attr('disabled', isDisabled)
  this.element.attr('title', isDisabled ? 'Brak wyników dla obecnych parametrów wyszukiwania' : '')
}

function SearchResult (searchResult) {
  for (const k in searchResult) {
    if (searchResult.hasOwnProperty(k)) {
      this[k] = searchResult[k]
    }
  }

  this.MinDate = searchResult.MinDate ? moment(new Date(parseInt(searchResult.MinDate.substr(6)))) : null
  this.MaxDate = searchResult.MaxDate ? moment(new Date(parseInt(searchResult.MaxDate.substr(6)))) : null

  this.hasNoResults =
        !this.Destinations.length ||
        !this.DestinationAirports.length ||
        !this.Durations.length ||
        !this.Prices.length ||
        !this.Rooms.length ||
        !this.Meals ||
        !this.MinAdultsCount ||
        !this.MaxAdultsCount
}

function init () {
  const mainSearchController = new SearchFilterController($('.main-search'), false)
  mainSearchController.callSearch()

  const isWrapped = $('form.offer-search-simple').parents('.main-search').length
  if (!isWrapped) {
    const simpleSearchController = new SearchFilterController($('.offer-search-simple'), true)
    simpleSearchController.callSearch()
  }

  screenPositionOnSelect()
}

module.exports = {
  init,
}



// WEBPACK FOOTER //
// ./src/modules/searchFilter.js